import React from 'react';
import { bonos } from '../data/bonos';
export function Bonos() {
  return <section aria-labelledby="bonos-titulo" className="w-full bg-canvas px-6 py-20" data-id="element-18" data-mp="2hcl1wor3cv91">
      <div className="mx-auto max-w-content" data-id="element-19" data-mp="2ha762dol7f0f">
        <div className="text-center" data-id="element-20" data-mp="2ld3uwm4q07ct">
          <h2 id="bonos-titulo" className="font-display text-3xl font-bold text-ink sm:text-4xl" data-id="element-21" data-mp="2lc26lfyp1od5">
            🎁 5 Bonos profesionales incluidos
          </h2>
          <p className="mt-4 text-muted" data-id="element-22" data-mp="2v2wu0nnoeu06">Sin costo adicional. Incluidos en tu acceso de hoy.</p>
        </div>

        <ul className="mt-12 grid gap-6 md:grid-cols-2 lg:grid-cols-3" data-id="element-23" data-mp="301rlsf3mfswf">
          {bonos.map(bono => <li key={bono.numero} className="flex h-full flex-col rounded-3xl border border-edge bg-surface p-7" data-id="element-24" data-mp="352nposnz3f1u">
              <div className="flex items-center justify-between" data-id="element-25" data-mp="1aoegamjrvytq">
                <span className="rounded-full bg-soft px-3 py-1 text-[11px] font-bold uppercase tracking-wider text-brand-700" data-id="element-26" data-mp="1aq7ow7dy4t4d">
                  Bono {bono.numero}
                </span>
                <span className="text-xl" aria-hidden="true" data-id="element-27" data-mp="3e5c2u6ozuajg">
                  {bono.icono}
                </span>
              </div>

              <h3 className="mt-4 font-display text-lg font-bold leading-snug text-ink" data-id="element-28" data-mp="34dy80c7zlywn">{bono.nombre}</h3>
              <p className="mt-3 text-sm leading-relaxed text-muted" data-id="element-29" data-mp="2zfmyk2lltqey">{bono.descripcion}</p>

              <div className="mt-auto flex flex-wrap items-center justify-between gap-2 pt-6 text-sm" data-id="element-30" data-mp="x7msq3u3fad">
                <span className="text-muted line-through" data-id="element-31" data-mp="3s4229szacmaz">Valor: {bono.valor}</span>
                <span className="rounded-full bg-brand-500 px-3 py-1 text-[11px] font-bold uppercase tracking-wider text-ink" data-id="element-32" data-mp="3n4pdv3srn76a">
                  Incluido hoy
                </span>
              </div>
            </li>)}
        </ul>
      </div>
    </section>;
}